import { request } from '../api';
import { useLeaderboardStore } from '../stores';
import { storeDidCatch } from '../utils';

export const getWeeklyLeaderboard = async () => {
  try {
    const { setWeekly } = useLeaderboardStore.getState();

    const { data: { data } = {} } = await request.get('/leaderboard/weekly', {
      params: {
        offset: 0,
        limit: 10,
      },
    });

    setWeekly(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getWeeklyLeaderboard]', error);
  }
};

export const getTotalLeaderboard = async () => {
  try {
    const { setTotal } = useLeaderboardStore.getState();

    const { data: { data } = {} } = await request.get('/leaderboard/total', {
      params: {
        offset: 0,
        limit: 10,
      },
    });

    setTotal(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getTotalLeaderboard]', error);
  }
};
